import { ErrorMessages } from '@/constants/errorMessages';

const ApiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '';
const BadRequestStatus = 400;
const ContactMessageUrl = `${ApiBaseUrl}/api/contact/sendMessage`;
const EndsWithPunctuation = /[.!?]$/;
const ProjectRequestUrl = `${ApiBaseUrl}/api/getStarted/sendInquiry`;
const RequestTimeoutMs = 8000;
const TooManyRequestsStatus = 429;

export function createSubmissionId() {
  return crypto.randomUUID();
}

export function submitContactMessage(contactMessage) {
  return postSubmission(ContactMessageUrl, contactMessage);
}

export function submitProjectRequest(projectRequest) {
  return postSubmission(ProjectRequestUrl, projectRequest);
}

async function postSubmission(url, submission) {
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(submission),
      signal: AbortSignal.timeout(RequestTimeoutMs),
    });
    if (response.ok) return null;
    if (response.status === TooManyRequestsStatus) return ErrorMessages.submit.throttled;
    if (response.status === BadRequestStatus) return await readServerMessages(response);
    return ErrorMessages.submit.failed;
  } catch {
    return ErrorMessages.submit.failed;
  }
}

async function readServerMessages(response) {
  const responseBody = await response.json().catch(() => null);
  const serverMessages = Array.isArray(responseBody) ? responseBody.filter((serverMessage) => typeof serverMessage === 'string') : [];
  if (serverMessages.length === 0) return ErrorMessages.submit.failed;
  return serverMessages.map((serverMessage) => (EndsWithPunctuation.test(serverMessage) ? serverMessage : `${serverMessage}.`)).join(' ');
}